import { omit } from 'lodash'

export const getFormDataFields = (data) => {
  return {
    id: data?.id,
    name: data?.name,
    coverPhoto: data?.coverPhoto,
    bannerImage: data?.bannerImage,
    description: data?.description,
    body: data?.body,
    location: {
      ...data?.location || {},
      lat: data?.location?.lat?.toString(),
      long: data?.location?.long?.toString()
    },
    homepage: data?.homepage,
    founded: data?.founded,
    customAttributes: data?.customAttributes?.map(ca => omit(ca, '__typename')),
    private: data?.private,
    isDraft: data?.isDraft,
    keywords: data?.keywords?.map(k => ({
      values: k?.values?.map(v => omit(v, '__typename')),
      key: k?.key
    })),
    taxonomy: data?.taxonomy?.map(k => ({
      values: k?.values?.map(v => omit(v, '__typename')),
      key: k?.key
    })),
  }
}
